module.exports = __webpack_public_path__ + "static/media/chevron_left.43ba803c.svg";